export const Config = {
    domain:               import.meta.env.VITE_TAOO_SERVER_URL,
    socketServerLogin:    import.meta.env.VITE_SOCKET_SERVER_LOGIN,
    socketServerPassword: import.meta.env.VITE_SOCKET_SERVER_PASS,
    devClientUrl:         import.meta.env.VITE_TAOO_DEV_CLIENT_URL,
    isDevelopment:        import.meta.env.MODE === 'development',
    isProduction:         import.meta.env.MODE === 'production' || import.meta.env.PROD,
    qrAppDomain:          'https://qr.taoo.ai'
};
